var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { I18nService } from '@/services/i18n-service';
let RemoveCustomFieldActionContribution = class RemoveCustomFieldActionContribution {
    constructor(_i18nService) {
        this._i18nService = _i18nService;
    }
    registerCustomFieldActions(action) {
        action.registerCustomFieldAction({
            commandId: 'custom-field.remove',
            icon: 'SolidDelete',
            label: this._i18nService.t('global.btn.delete'),
            order: 5,
            divider: true, // 添加分割线
            isEnabled: (context) => {
                if (context.isPublicMode) {
                    return context.isAdmin || context.fields[0].create_by_me;
                }
                return true;
            },
            isVisible: (context) => {
                if (context.isPublicMode) {
                    return context.isAdmin || context.fields[0].create_by_me;
                }
                return true;
            },
        });
    }
};
RemoveCustomFieldActionContribution = __decorate([
    injectable(),
    __param(0, inject(I18nService)),
    __metadata("design:paramtypes", [typeof (_a = typeof I18nService !== "undefined" && I18nService) === "function" ? _a : Object])
], RemoveCustomFieldActionContribution);
export { RemoveCustomFieldActionContribution };
